// src/config/msalConfig.js
import { LogLevel, PublicClientApplication } from "@azure/msal-browser";

/**
 * Configuración para la autenticación de Azure AD con MSAL
 * Documentación: https://github.com/AzureAD/microsoft-authentication-library-for-js/tree/dev/lib/msal-browser
 */

// Configuración de MSAL
export const msalConfig = {
  auth: {
    clientId: process.env.REACT_APP_AZURE_AD_CLIENT_ID || "",
    authority: `https://login.microsoftonline.com/${process.env.REACT_APP_AZURE_AD_TENANT_ID || "common"}`,
    redirectUri: process.env.REACT_APP_AZURE_AD_REDIRECT_URI || window.location.origin,
    postLogoutRedirectUri: window.location.origin,
  },
  cache: {
    cacheLocation: "sessionStorage", // "sessionStorage" o "localStorage"
    storeAuthStateInCookie: false, // Set to true for IE 11 or Edge
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) {
          return;
        }
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            return;
        }
      },
      logLevel: LogLevel.Warning,
    },
  },
};

// Crear instancia de MSAL UNA SOLA VEZ usando patrón singleton
// Esto previene el warning de "already an instance of MSAL.js"
// Verificamos si ya existe una instancia en el window para evitar duplicados en HMR
let msalInstance;

if (typeof window !== 'undefined') {
  // Si ya existe una instancia en el window, la reutilizamos
  if (window.__MSAL_INSTANCE__) {
    msalInstance = window.__MSAL_INSTANCE__;
  } else {
    // Si no existe, creamos una nueva y la guardamos en el window
    msalInstance = new PublicClientApplication(msalConfig);
    window.__MSAL_INSTANCE__ = msalInstance;
  }
} else {
  // En entorno de servidor (SSR), simplemente creamos la instancia
  msalInstance = new PublicClientApplication(msalConfig);
}

export { msalInstance };

// Scopes para la API de Microsoft Graph
export const loginRequest = {
  scopes: ["User.Read"],
};

// Scopes adicionales para obtener información del perfil
export const graphConfig = {
  graphMeEndpoint: "https://graph.microsoft.com/v1.0/me",
};
